import { render, staticRenderFns } from "./comments-loading.vue?vue&type=template&id=7d0ab52e&"
import script from "./comments-loading.vue?vue&type=script&lang=js&"
export * from "./comments-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports